import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';
@Component({
  selector: 'app-faq-listing-page',
  templateUrl: './faq-listing-page.component.html',
  styleUrls: ['./faq-listing-page.component.scss'],
  animations: [
    trigger('accordionToggle', [
      state(
        'closed',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden'
        })
      ),
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      transition('closed <=> open', [animate('300ms ease-in-out')]),
    ]),
  ],
})

export class FaqListingPageComponent implements OnInit {
  faqData: any;
  remainingFaqs: any;
  combinedFaqsList: any;
  showButton = false;
  showFaqList = false; // Initially false to show only remainingFaqs
  faqtabDataAccordion: boolean[] = [];

  showHomeFaqList = true;
  openFaqIndex: number | null = null;
  isExpanded = false;
  faqAccordion: number | null = null;
  newJson: any;
  @Input() faqId: any
  openQuestionIndex: number | null = 0;
  oneAtATime: boolean = true;
  homepageFaq = false;

  constructor(private sharedService: SharedService, private renderer2: Renderer2, @Inject(DOCUMENT) private document: any,
    private router: Router,) { }

  ngOnInit(): void {
    const urlSegments = this.router.url.split('/');
    this.retrieveFaqDetails(this.faqId, urlSegments);
  }

  retrieveFaqDetails(queryKey: string, urlSegments: any) {
    this.sharedService.retrieveFaqDetails(queryKey, urlSegments).subscribe((res: any) => {
      this.faqData = res?.data ?? [];
      this.combinedFaqsList = []; // Initialize or clear the combinedFaqsList
      if (this.faqId !== 'Homepage') {
        this.homepageFaq = false;
        if (this.faqData.dynamicFaqsList && this.faqData.dynamicFaqsList.length > 0) {
          // Filter dynamicFaqsList to only include items with tabularDataList
          this.combinedFaqsList = this.faqData.dynamicFaqsList.filter(
            (faq: any) => faq.tabularDataList && faq.tabularDataList.length > 0
          );

          // Initialize remainingFaqs with the filtered combinedFaqsList
          this.remainingFaqs = [...this.combinedFaqsList];

          // Add the fourth item (index 3) to remainingFaqs if it exists
          if (this.faqData.dynamicFaqsList[3]) {
            this.remainingFaqs.push(this.faqData.dynamicFaqsList[3]);
            this.combinedFaqsList.push(this.faqData.dynamicFaqsList[3]);
          }

          this.showButton = true;
        } else {
          this.showFaqList = true;
          this.showButton = false;
        }

        // Add faqsList to combinedFaqsList if available
        if (this.faqData?.faqsList?.length > 0) {
          this.combinedFaqsList = this.combinedFaqsList.concat(this.faqData.faqsList);
        } else {
          this.showButton = false;
        }
        if (this.combinedFaqsList?.length > 0) {
          this.setFaqListSchema(this.combinedFaqsList);
        }

        // Process combinedFaqsList if it has data

      } else {
        this.homepageFaq = true;
        this.combinedFaqsList = this.faqData?.faqsList?.slice(0, 5);
        if (this.combinedFaqsList?.length > 0) {
          this.setFaqListSchema(this.faqData?.faqsList);
        }
      }

    }, error => {
      console.error('Error retrieving FAQ details:', error);
      this.faqData = [];
    });
  }

  toggleFaqList() {
    this.showFaqList = !this.showFaqList;
  }

  faqToggle(index: number) {
    // this.faqAccordion[index] = !this.faqAccordion[index];
    if (this.faqAccordion === index) {
      this.faqAccordion = null; // Close the currently opened FAQ
    } else {
      this.faqAccordion = index; // Open the new FAQ
    }
  }

  // Toggle FAQ, close others when opening a new one
  faqHomepageToggle(index: number) {
    if (this.openFaqIndex === index) {
      this.openFaqIndex = null; // Close the currently opened FAQ
    } else {
      this.openFaqIndex = index; // Open the new FAQ
    }
  }

  // Toggle between showing more or less FAQs
  toggleFaqVisibility() {
    if (this.isExpanded) {
      // Show less, reset to only initial set of FAQs
      this.combinedFaqsList = this.faqData.faqsList.slice(0, 5);
    } else {
      // Show more, display all FAQs
      this.combinedFaqsList = [...this.faqData.faqsList];
    }
    this.isExpanded = !this.isExpanded; // Toggle expansion state
  }

  faqTabToggle(index: number) {
    this.faqtabDataAccordion[index] = !this.faqtabDataAccordion[index];
  }

  getFormattedAnswer(answer: string): string {
    const formattedAnswer = answer.replace(/(\d+)/, '<b>$1</b>');
    return formattedAnswer;
  }

  setFaqListSchema(faqData: any) {
    if (this.sharedService.isServer) {
      let tag = this.renderer2.createElement('script');
      tag.type = "application/ld+json";
      tag.text = this.getFaqSchema(faqData);
      this.renderer2.appendChild(this.document.head, tag);
    }
  }

  getFaqSchema(faqDatas: Faq[]): string {
    let schemaObj: FaqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": []
    };

    for (let faq of faqDatas) {
      // Base structure for FAQ item
      let faqItem: FaqMainEntity = {
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      };

      // If there's tabular data, append it to the answer as an HTML table
      if (faq?.tabularDataList && faq?.tabularDataList.length > 0) {
        let tableContent = `<table><thead><tr>
                              <th>Tender Title</th>
                              <th>Closing Date</th>
                              <th>Authority Name</th>
                            </tr></thead><tbody>`;

        faq.tabularDataList.forEach(tabledata => {
          tableContent += `<tr>
                            <td><a href="${tabledata.detailPageUrl}">${tabledata.tenderTitle || tabledata.categoryName}</a></td>
                            <td>${tabledata.closingDate ? new Date(tabledata.closingDate).toLocaleDateString() : ''}</td>
                            <td>${tabledata.authorityName || tabledata.categoryCount}</td>
                           </tr>`;
        });

        tableContent += `</tbody></table>`;

        // Append the table HTML to the answer text
        faqItem.acceptedAnswer.text += `<br/>${tableContent}`;
      }

      // Add the FAQ item to the schema
      schemaObj.mainEntity.push(faqItem);
    }
    return JSON.stringify(schemaObj);
  }
}

interface Faq {
  question: string;
  answer: string;
  tabularDataList?: TabularData[]; // Optional property for tabular data
}

interface TabularData {
  tenderTitle?: string;
  categoryName?: string;
  closingDate?: string;
  authorityName?: string;
  categoryCount?: number;
  detailPageUrl: string;
}

interface FaqSchema {
  "@context": string;
  "@type": string;
  mainEntity: FaqMainEntity[];
}

interface FaqMainEntity {
  "@type": string;
  name: string;
  acceptedAnswer: {
    "@type": string;
    text: string;
  };
}